module.exports = __webpack_public_path__ + "img/huanke.png";